var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Templates",
    transform: "translate(-1038.000000, -364.000000)",
    fill: "#8892B0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1019.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.125,96.375 C23.850625,96.375 25.25,97.774375 25.25,99.5 C25.25,101.225625 23.850625,102.625 22.125,102.625 C20.399375,102.625 19,101.225625 19,99.5 C19,97.774375 20.399375,96.375 22.125,96.375 Z M29.07625,103.915625 C29.030625,104.10375 29,104.2975 29,104.5 C29,105.880625 30.119375,107 31.5,107 C32.880625,107 34,105.880625 34,104.5 C34,103.119375 32.880625,102 31.5,102 C30.771875,102 30.1225,102.31625 29.665625,102.813125 L26.235625,100.98375 C26.091875,101.38125 25.8925,101.751875 25.64625,102.08625 L29.07625,103.915625 L29.07625,103.915625 Z M34,94.5 C34,93.119375 32.880625,92 31.5,92 C30.119375,92 29,93.119375 29,94.5 C29,94.7025 29.030625,94.89625 29.07625,95.084375 L25.64625,96.91375 C25.893125,97.248125 26.091875,97.618125 26.235625,98.01625 L29.665625,96.186875 C30.1225,96.68375 30.771875,97 31.5,97 C32.880625,97 34,95.880625 34,94.5 Z",
    id: "Shape-Copy-7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareList);
export default __webpack_public_path__ + "static/media/share-list.899a2630053d547ffaf98d783fd46a22.svg";
export { ForwardRef as ReactComponent };